import { AttachFile, CalendarMonth, CreditCard, Email, Female, Home, Image, Male, People, Phone, Upload, Visibility } from "@mui/icons-material";
import { Alert, Avatar, Box, Button, Card, CardContent, Chip, CircularProgress, Container, Dialog, DialogContent, Divider, FormControl, Grid, InputLabel, MenuItem, Select, Stack, Typography } from "@mui/material";
import { styled } from "@mui/material/styles";
import axios from "axios";
import { useEffect, useState } from "react";

export default function Profile({ snackbar }) {
	const apiUrl = process.env.REACT_APP_API;
	const [action, setAction] = useState("");
	const [open, setOpen] = useState("");

	const VisuallyHiddenInput = styled("input")({
		clip: "rect(0 0 0 0)",
		clipPath: "inset(50%)",
		height: 1,
		overflow: "hidden",
		position: "absolute",
		bottom: 0,
		left: 0,
		whiteSpace: "nowrap",
		width: 1,
	});

	const [profile, setProfile] = useState([]);
	useEffect(() => {
		get_profile();
		get_documents();
	}, []);

	const get_profile = async () => {
		try {
			const response = await axios.post(`${apiUrl}/student/v2?action=profile`);
			if (response.data.status === true) {
				setProfile(response.data.data);
			} else {
				setProfile(response.data);
			}
		} catch (error) {
			console.log(error);
		} finally {
		}
	};

	const [document, setDocument] = useState([]);
	const get_documents = async () => {
		try {
			const response = await axios.post(`${apiUrl}/student/v2?action=documents`);
			if (response.data.status === true) {
				setDocument(response.data.data);
			} else {
				setDocument(response.data);
			}
		} catch (error) {
			console.log(error);
		} finally {
		}
	};

	const [docType, setDocType] = useState("");
	const upload_document = async (img) => {
		try {
			setAction("uploadingdocument");
			let formData = new FormData();
			formData.append("documentType", docType);
			formData.append("img", img.target.files[0]);
			const response = await axios.post(`${apiUrl}/student/v2?action=upload-document`, formData);
			snackbar(response.data.msg);
			if (response.data.status === true) {
				get_documents();
			}
		} catch (error) {
			console.log(error);
		} finally {
			setAction("");
		}
	};

	const [docImg, setDocImg] = useState("");

	return (
		<Box>
			<Dialog
				open={open === "opendocument" ? true : false}
				onClose={() => setOpen("")}
				PaperProps={{
					sx: {
						borderRadius: 2,
						boxShadow: 'none',
						border: '1px solid',
						borderColor: 'rgba(0, 0, 0, 0.07)'
					}
				}}
			>
				<DialogContent>
					<img src={`../../spywareassets/student/document/${docImg}`} style={{ width: '100%', borderRadius: 8 }} />
				</DialogContent>
			</Dialog>
			<Container maxWidth="lg">
				<Box sx={{ py: 2 }}>
					{/* Page Header */}
					<Box sx={{ mb: 3 }}>
						<Typography variant="h5" fontWeight={700} mb={1} className="orbitron">
							My Profile
						</Typography>
						<Typography variant="body2" color="text.secondary" fontSize={13}>
							View and manage your personal information, guardian details, and uploaded documents.
						</Typography>
					</Box>

					<Grid container spacing={2}>
						{/* Profile Card */}
						<Grid item xs={12} md={6}>
							<Card sx={{ borderRadius: 2, backgroundColor: 'white', boxShadow: 'none', border: '1px solid', borderColor: 'rgba(0, 0, 0, 0.07)', height: "100%" }}>
								<CardContent sx={{ p: 3 }}>
									{/* Avatar Section */}
									<Stack alignItems="center" mb={3}>
										<Avatar
											src={`../../spywareassets/student/${profile.studentid}.jpg`}
											sx={{
												width: 100,
												height: 100,
												border: '3px solid',
												borderColor: 'primary.main'
											}}
										/>
										<Typography mt={2} variant="h6" fontWeight={700}>
											{profile.name}
										</Typography>
										<Stack direction="row" spacing={1} mt={1}>
											<Chip
												icon={<CalendarMonth sx={{ fontSize: 16 }} />}
												size="small"
												label={new Date(profile.birth).toLocaleDateString(undefined, { day: "2-digit", month: "short", year: "numeric" })}
												sx={{ fontSize: 11, height: 24 }}
											/>
											<Chip
												label={profile.gender}
												icon={profile.gender === "Male" ? <Male sx={{ fontSize: 16 }} /> : <Female sx={{ fontSize: 16 }} />}
												size="small"
												sx={{ fontSize: 11, height: 24 }}
											/>
										</Stack>
									</Stack>

									{/* Contact Information */}
									<Stack spacing={2}>
										<Box>
											<Stack direction="row" alignItems="center" spacing={1} mb={0.5}>
												<Box sx={{
													width: 28,
													height: 28,
													borderRadius: 1.5,
													backgroundColor: '#DBEAFE',
													display: 'flex',
													alignItems: 'center',
													justifyContent: 'center'
												}}>
													<Email sx={{ color: '#2563EB', fontSize: 16 }} />
												</Box>
												<Typography variant="caption" color="text.secondary" fontSize={11} fontWeight={600}>
													Email Address
												</Typography>
											</Stack>
											<Typography variant="body2" fontWeight={600} ml={4.5}>
												{profile.email}
											</Typography>
										</Box>

										<Box>
											<Stack direction="row" alignItems="center" spacing={1} mb={0.5}>
												<Box sx={{
													width: 28,
													height: 28,
													borderRadius: 1.5,
													backgroundColor: '#D1FAE5',
													display: 'flex',
													alignItems: 'center',
													justifyContent: 'center'
												}}>
													<Phone sx={{ color: '#059669', fontSize: 16 }} />
												</Box>
												<Typography variant="caption" color="text.secondary" fontSize={11} fontWeight={600}>
													Mobile Number
												</Typography>
											</Stack>
											<Typography variant="body2" fontWeight={600} ml={4.5}>
												{profile.mobile}
											</Typography>
										</Box>

										<Box>
											<Stack direction="row" alignItems="center" spacing={1} mb={0.5}>
												<Box sx={{
													width: 28,
													height: 28,
													borderRadius: 1.5,
													backgroundColor: '#FEF3C7',
													display: 'flex',
													alignItems: 'center',
													justifyContent: 'center'
												}}>
													<Home sx={{ color: '#D97706', fontSize: 16 }} />
												</Box>
												<Typography variant="caption" color="text.secondary" fontSize={11} fontWeight={600}>
													Address
												</Typography>
											</Stack>
											<Typography variant="body2" fontWeight={600} ml={4.5}>
												{profile.address}
											</Typography>
										</Box>
									</Stack>
								</CardContent>
							</Card>
						</Grid>

						{/* Additional Details Card */}
						<Grid item xs={12} md={6}>
							<Stack spacing={2} height="100%">
								{/* Aadhaar & Guardian Details */}
								<Card sx={{ borderRadius: 2, backgroundColor: 'white', boxShadow: 'none', border: '1px solid', borderColor: 'rgba(0, 0, 0, 0.07)' }}>
									<CardContent sx={{ p: 2 }}>
										{/* Aadhaar */}
										<Box mb={2}>
											<Stack direction="row" alignItems="center" spacing={1} mb={0.5}>
												<Box sx={{
													width: 28,
													height: 28,
													borderRadius: 1.5,
													backgroundColor: '#FEE2E2',
													display: 'flex',
													alignItems: 'center',
													justifyContent: 'center'
												}}>
													<CreditCard sx={{ color: '#DC2626', fontSize: 16 }} />
												</Box>
												<Typography variant="caption" color="text.secondary" fontSize={11} fontWeight={600}>
													Aadhaar Number
												</Typography>
											</Stack>
											<Typography variant="body2" fontWeight={600} ml={4.5}>
												{profile.aadhaar}
											</Typography>
										</Box>

										<Divider sx={{ my: 2 }} />

										{/* Guardian Details Header */}
										<Stack direction="row" alignItems="center" spacing={1} mb={2}>
											<Box sx={{
												width: 28,
												height: 28,
												borderRadius: 1.5,
												backgroundColor: '#DBEAFE',
												display: 'flex',
												alignItems: 'center',
												justifyContent: 'center'
											}}>
												<People sx={{ color: '#2563EB', fontSize: 16 }} />
											</Box>
											<Typography variant="body2" fontWeight={700}>
												Guardian Details
											</Typography>
										</Stack>

										{/* Father Name */}
										<Box mb={1.5}>
											<Typography variant="caption" color="text.secondary" fontSize={11} fontWeight={600}>
												Father's Name
											</Typography>
											<Typography variant="body2" fontWeight={600}>
												{profile.guardian}
											</Typography>
										</Box>

										{/* Mother Name */}
										<Box>
											<Typography variant="caption" color="text.secondary" fontSize={11} fontWeight={600}>
												Mother's Name
											</Typography>
											<Typography variant="body2" fontWeight={600}>
												{profile.mother}
											</Typography>
										</Box>
									</CardContent>
								</Card>

								{/* Documents Upload Card */}
								<Card sx={{ borderRadius: 2, backgroundColor: 'white', boxShadow: 'none', border: '1px solid', borderColor: 'rgba(0, 0, 0, 0.07)', flexGrow: 1 }}>
									<CardContent sx={{ p: 2 }}>
										<Stack direction="row" alignItems="center" spacing={1} mb={2}>
											<Box sx={{
												width: 28,
												height: 28,
												borderRadius: 1.5,
												backgroundColor: '#D1FAE5',
												display: 'flex',
												alignItems: 'center',
												justifyContent: 'center'
											}}>
												<Upload sx={{ color: '#059669', fontSize: 16 }} />
											</Box>
											<Typography variant="body2" fontWeight={700}>
												Upload Documents
											</Typography>
										</Stack>

										<Stack spacing={1.5}>
											<FormControl fullWidth size="small">
												<InputLabel id="demo-simple-select-label">Document Type</InputLabel>
												<Select
													onChange={(event) => setDocType(event.target.value)}
													value={docType}
													labelId="demo-simple-select-label"
													id="demo-simple-select"
													label="Document Type"
												>
													<MenuItem value={"aadhaar card"}>Aadhaar Card</MenuItem>
													<MenuItem value={"marksheet"}>Marksheet</MenuItem>
													<MenuItem value={"others"}>Others</MenuItem>
												</Select>
											</FormControl>
											<Button
												fullWidth
												component="label"
												disabled={action === "uploadingdocument" ? true : false}
												role={undefined}
												variant="contained"
												size="small"
												startIcon={action === "uploadingdocument" ? <CircularProgress color="inherit" size={16} /> : <Image />}
												sx={{ textTransform: 'none', fontSize: 13 }}
											>
												Upload Document
												<VisuallyHiddenInput onChange={(event) => upload_document(event)} type="file" accept=".jpeg, .jpg" />
											</Button>
										</Stack>

										{document.status === false ? (
											<Alert sx={{ mt: 2, fontSize: 12, py: 0.5 }} severity="info">
												{document.msg}
											</Alert>
										) : (
											<Box mt={2}>
												<Typography variant="caption" color="text.secondary" fontSize={11} fontWeight={600} mb={1} display="block">
													Uploaded Documents ({document.length})
												</Typography>
												<Stack spacing={1}>
													{document.map((item, index) => {
														return (
															<Stack key={index} direction="row" spacing={1}>
																<Chip
																	sx={{ borderRadius: 1.5, textTransform: "capitalize", fontSize: 11, flexGrow: 1 }}
																	size="small"
																	icon={<AttachFile sx={{ fontSize: 16 }} />}
																	label={item.document_type}
																/>
																<Chip
																	onClick={() => {
																		setDocImg(item.document_file);
																		setOpen("opendocument");
																	}}
																	sx={{ borderRadius: 1.5, fontSize: 11 }}
																	clickable
																	size="small"
																	color="primary"
																	icon={<Visibility sx={{ fontSize: 16 }} />}
																	label="View"
																/>
															</Stack>
														);
													})}
												</Stack>
											</Box>
										)}
									</CardContent>
								</Card>
							</Stack>
						</Grid>
					</Grid>
				</Box>
			</Container>
		</Box>
	);
}
